__turbopack_context__.v({
  "bold": "credit-matters-table-module-scss-module__Xqn_Lq__bold",
  "buttons": "credit-matters-table-module-scss-module__Xqn_Lq__buttons",
  "copy": "credit-matters-table-module-scss-module__Xqn_Lq__copy",
  "fineprint": "credit-matters-table-module-scss-module__Xqn_Lq__fineprint",
  "heading": "credit-matters-table-module-scss-module__Xqn_Lq__heading",
  "imageContainer": "credit-matters-table-module-scss-module__Xqn_Lq__imageContainer",
  "learnMore": "credit-matters-table-module-scss-module__Xqn_Lq__learnMore",
  "other": "credit-matters-table-module-scss-module__Xqn_Lq__other",
  "otherSubtititle": "credit-matters-table-module-scss-module__Xqn_Lq__otherSubtititle",
  "table": "credit-matters-table-module-scss-module__Xqn_Lq__table",
  "tableData": "credit-matters-table-module-scss-module__Xqn_Lq__tableData",
  "tableDataLeft": "credit-matters-table-module-scss-module__Xqn_Lq__tableDataLeft",
  "tableHeader": "credit-matters-table-module-scss-module__Xqn_Lq__tableHeader",
  "tableRow": "credit-matters-table-module-scss-module__Xqn_Lq__tableRow",
  "wrapper": "credit-matters-table-module-scss-module__Xqn_Lq__wrapper",
});
